// extracted by mini-css-extract-plugin
export var downArrow = "_ao-0";
export var infoTooltipIcon = "_ao-3";
export var label = "_ao-1";
export var optionCard = "_ao-4";
export var upArrow = "_ao-2";